import React, { FunctionComponent } from 'react';

import { SaveQuoteComplete as CommonSaveQuoteComplete } from 'scenes/common/components/SaveQuoteComplete';
import { getEffectiveEndDate } from 'scenes/common/selectors/configSelectors';
import analytics from 'scenes/motor/analytics';
import {
  getPolicyStartDate,
  getQuoteNumber,
  getSaveQuoteEmailAddress,
} from 'scenes/motor/selectors';
import { MotorFullPageProps } from 'scenes/motor/types';
import { QuoteSaved } from './QuoteSaved';

export const SaveQuoteComplete: FunctionComponent<Pick<
  MotorFullPageProps,
  'funnelState' | 'onResumeQuote'
>> = ({ funnelState, onResumeQuote }) => (
  <CommonSaveQuoteComplete
    onResumeQuote={() => {
      analytics().resumeQuote(funnelState);
      onResumeQuote();
    }}
    quoteNumber={getQuoteNumber(funnelState)}
    saveQuoteEmailAddress={getSaveQuoteEmailAddress(funnelState)}
    Image={() => <QuoteSaved />}
    polocyStartDate={getPolicyStartDate(funnelState)}
    effectiveEndDate={getEffectiveEndDate(funnelState.apiResponses.config)}
  />
);

export default SaveQuoteComplete;
